<template>
  <div>
    <b-card no-body class="mb-0">
      <div class="loading_page" v-if="indicator">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
      </div>
      <div class="m-2">
        <washer-plan-form :form="form" :errors="errors" :rows="rows" @submit="handleSubmit"></washer-plan-form>
      </div>
    </b-card>
  </div>
</template>

<script>

import {
  BCard, BRow, BCol
} from 'bootstrap-vue'
import { OrbitSpinner } from 'epic-spinners'
import store from '@/store'
import { PlanStore } from "@/app/plans/containerDump/state";
import flatPickr from 'vue-flatpickr-component'
import Ripple from "vue-ripple-directive"
import WasherPlanForm from '@/views/modules/plans/washer-plan/share/WasherPlanForm.vue'
import { useWasherPlanForm } from '@/views/modules/plans/washer-plan/composable/useWasherPlanForm'
import { useWasherPlanApi } from '@/views/modules/plans/washer-plan/composable/useWasherPlanApi'
import { ref } from '@vue/composition-api'


export default {
  components: {
    BRow, BCol, BCard,
    OrbitSpinner,
    flatPickr,
    WasherPlanForm
  },
  directives: {
    Ripple,
  },

  setup(props, { root }) {

    const errors = ref({})
    const indicator = ref(false)

    const { form, rows, buildFormData, clearFormData } = useWasherPlanForm()
    const { save } = useWasherPlanApi()

    const handleSubmit = async () => {
      indicator.value = true
      const formData = buildFormData()
      save(formData).then(r => {
        console.log('Done!')
        clearFormData()
          root.$bvToast.toast(root.$t('Washer plan created successfully'), {
            title: root.$t("success"),
            variant: 'success',
            solid: false,
          })
      }).catch(e => {
        errors.value = e.response.data.errors
        console.log(e.response.data.errors)
          root.$bvToast.toast(root.$t("did not save the plan!"), {
            title: root.$t("Error"),
            variant: 'danger',
            solid: false,
          })
      }).finally(_ => indicator.value = false)
    }

    return {

      indicator,
      form,
      errors,
      rows,
      handleSubmit,

    }
  }

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
